
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Homepage from './Pages/Homepage';
import Coinpage from './Pages/Coinpage';
import { makeStyles } from '@material-ui/core';
import Alert from './components/Alert';



const useStyles = makeStyles(()=>({
  App:{
    backgroundColor: "#000080",
    color:"white",
    minHeight:"100vh"
  },
}));



function App() {

  const classes = useStyles()

  return (
    <BrowserRouter>
      <div className={classes.App}>
          <Header/>
          <Routes>
            <Route path='/' element={<Homepage/>} />
            <Route path='/coins/:id' element={<Coinpage/>} />
          </Routes>
      </div>
      <Alert/>
    </BrowserRouter>
  );
}

export default App;
